import enMessages from "@shared/locales/en.js";
import ruMessages from "@shared/locales/ru.js";
import { useSettingsStore } from "@shared/store/settings.store";
import type { ReactNode } from "react";
import { IntlProvider as Provider } from "react-intl";

const messages = {
	ru: ruMessages,
	en: enMessages,
};

type IntlProviderProps = {
	children: ReactNode;
};

export function IntlProvider({ children }: IntlProviderProps) {
	const { locale } = useSettingsStore();
	return (
		<Provider locale={locale} messages={messages[locale]}>
			{children}
		</Provider>
	);
}
